export default "__VITE_ASSET__Dx7fuNt___"